import { css } from 'styled-components';
import color from './colors';
var linkStyles = {
  standard: {
    color: color('black'),
    border: "2px solid ".concat(color('black')),
    weight: 'normal',
    hoverColor: color('black'),
    hoverBorder: "2px solid ".concat(color('black'))
  },
  standard_white: {
    color: color('white'),
    border: "2px solid ".concat(color('white')),
    weight: 'normal',
    hoverColor: color('white'),
    hoverBorder: "2px solid ".concat(color('white'))
  }
};
export default (function (styleName, underline) {
  var style = css(["color:", ";border-bottom:solid 2px;border-bottom-color:inherit;font-weight:normal;:hover{color:inherit;font-weight:700;}"], color('black'));

  if (styleName) {
    style = css(["color:", ";border-bottom:", ";font-weight:", ";:hover{color:", ";border-bottom:", ";font-weight:", ";}"], linkStyles[styleName].color, underline && linkStyles[styleName].border, linkStyles[styleName].weight, linkStyles[styleName].hoverColor, underline && linkStyles[styleName].hoverBorder, linkStyles[styleName].hoverWeight);
  }

  return style;
});